import { useLazyFetchAdviserLeagueTableQuery } from "../../../services/headofficeadmin";
import { useFetchAdviserLeagueTableQuery } from "../../../services/headofficeadmin";
import { useFilterContext } from "../../../hooks/FilterContext";

const useAdviserLeagueTable = () => {

    const {filter } = useFilterContext();

    const { data, isLoading, isFetching, isError, error } = useFetchAdviserLeagueTableQuery({
    data:{
        ...filter,
        adviserIds: filter?.advisers?.map(x => x.value) ?? [],
    }});


    return {
        data,
        isFetching,
        isLoading,
        isError,
        error,
    }
};

export default useAdviserLeagueTable;